import { render, staticRenderFns } from "./IconIfyIcon.vue?vue&type=template&id=a1fec8d2&scoped=true&"
import script from "./IconIfyIcon.vue?vue&type=script&lang=js&"
export * from "./IconIfyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fec8d2",
  null
  
)

export default component.exports